import { render, staticRenderFns } from "./edit-tenant.vue?vue&type=template&id=4369994c&"
import script from "./edit-tenant.vue?vue&type=script&lang=ts&"
export * from "./edit-tenant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports